var _path, _line, _line2, _line3, _line4, _line5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHiEditInfoOfferPrice(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.5 13.5H13.5V2.5H10.4444H9.83333C9.42872 3.46511 8.81761 3.94766 8 3.94766C7.18239 3.94766 6.57128 3.46511 6.16667 2.5H5.55556H2.5V13.5Z",
    stroke: "#616B84",
    strokeWidth: 1.2,
    strokeLinejoin: "round"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 4.5,
    y1: 6.5,
    x2: 6.5,
    y2: 6.5,
    stroke: "#B1B6C2",
    strokeLinecap: "round"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 9.5,
    y1: 10,
    x2: 11.5,
    y2: 10,
    stroke: "#B1B6C2",
    strokeLinecap: "round"
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 9.5,
    y1: 11.5,
    x2: 11.5,
    y2: 11.5,
    stroke: "#B1B6C2",
    strokeLinecap: "round"
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    x1: 5.5,
    y1: 5.5,
    x2: 5.5,
    y2: 7.5,
    stroke: "#B1B6C2",
    strokeLinecap: "round"
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    x1: 10.9349,
    y1: 5.84603,
    x2: 4.84603,
    y2: 11.0651,
    stroke: "#616B84",
    strokeWidth: 1.2,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHiEditInfoOfferPrice);
export default __webpack_public_path__ + "static/media/hi-edit-info-offer-price.ed342ba73e7e2562755e42f14a670c04.svg";
export { ForwardRef as ReactComponent };